import { toast } from 'react-toastify';

import { setIsLoading, setToken, setErrors, clearErrors } from './actions';

import {
  requestToken,
  requestCreateToken,
  requestUpdateToken,
  requestRenewToken,
  requestRemoveToken
} from './services';

export const loadToken = (userId, businessUuid, userIntegrationId) => dispatch => {
  dispatch(setIsLoading(true));

  return requestToken(userId, businessUuid, userIntegrationId)
    .then(({ data }) => dispatch(setToken(data)))
    .finally(() => dispatch(setIsLoading(false)));
}

export const upsertToken = (userId, businessUuid, userIntegrationId, params) => dispatch => {
  dispatch(setIsLoading(true));

  if(!userIntegrationId) {
    return requestCreateToken(userId, businessUuid, params)
      .then(({ data }) => {
        dispatch(clearErrors());
        toast.success('Token cadastrado com sucesso.');
        return Promise.resolve(data);
      })
      .catch(error => {
        if(!error) {
          dispatch(clearErrors());
          return Promise.reject();
        }

        dispatch(setErrors(error));
        return Promise.reject();
      })
      .finally(() => dispatch(setIsLoading(false)));
  }

  return requestUpdateToken(userId, businessUuid, userIntegrationId, params)
    .then(() => {
      dispatch(clearErrors());
      toast.success('Token atualizado com sucesso.');
      return Promise.resolve();
    })
    .catch(error => {
      if(!error) {
        dispatch(clearErrors());
        return Promise.reject();
      }

      dispatch(setErrors(error));
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const renewToken = (userId, businessUuid, userIntegrationId, params) => dispatch => {
  dispatch(setIsLoading(true));

  return requestRenewToken(userId, businessUuid, userIntegrationId, params)
    .then(({ data }) => {
      toast.success('Token renovado com sucesso.');
      return Promise.resolve(data);
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const removeToken = (userId, businessUuid, userIntegrationId) => dispatch => {
  dispatch(setIsLoading(true));

  return requestRemoveToken(userId, businessUuid, userIntegrationId)
    .then(() => toast.success('Token removido com sucesso.'))
    .finally(() => dispatch(setIsLoading(false)));
}